import React, { useEffect, useState, useCallback } from "react";
import DatePicker from "react-datepicker";

import { parseComplexDate } from "../../util/util";

import "./DatePicker.css";

import { registerLocale } from "react-datepicker";
import tr from "date-fns/locale/tr";
import enUS from "date-fns/locale/en-US";
import { parseISO } from "date-fns";
import { useTranslation } from "react-i18next";

const DateSelect = (props) => {
  const { i18n } = useTranslation();
  const [date, setDate] = useState();

  const locale = i18n.resolvedLanguage === "tr" ? tr : enUS;
  registerLocale(i18n.resolvedLanguage, locale);

  const initialValue = props.initialValue;
  const id = props.id;
  const onInput = props.onInput;

  useEffect(() => {
    if (initialValue) {
      setDate(parseISO(initialValue));
      onInput(id, initialValue, true);
    }
  }, [initialValue, id, onInput]);

  const handleChange = useCallback(
    (selectedDate) => {
      if (selectedDate) {
        setDate(selectedDate);
        props.onInput(props.id, parseComplexDate(selectedDate), true);
      } else {
        if (props.nonrequired) {
          props.onInput(props.id, "", true);
          setDate("");
        } else {
          props.onInput(props.id, "", false);
          setDate("");
        }
      }
    },
    [props]
  );

  return (
    <div className="generic-input" style={{ marginTop: 0 }}>
      <label htmlFor={props.id}>{props.label}</label>

      <DatePicker
        autoComplete="off"
        id={props.id}
        dateFormat="yyyy-MM-dd"
        locale={i18n.resolvedLanguage}
        className="date-picker"
        selected={date}
        onChange={(date) => handleChange(date)}
      />
    </div>
  );
};

export default DateSelect;
